import { makeStyles } from '@material-ui/core/styles';
import { BorderBottom } from '@material-ui/icons';

export const useStyles = makeStyles((theme) => ({
  tooltip_text: {
    letterSpacing: '0.09rem',
    fontSize: '12px',
  },

  other_birads_chip: {
    margin: '0',
    height: '20px',
    textTransform: 'uppercase',
    minWidth: 'fit-content',
    width: '80px',
    borderRadius: '5px',
    fontSize: theme.fonts.responsiveSmall,
    lineHeight: '1',
    textAlign: 'center',
    lineHeight: '22px',
  },

  diagnostic_sections_container: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    width: '100%',
    padding: '0 10px',
  },

  lesions_main_container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
    alignItems: 'flex-end',
  },

  lesions_container: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '0 6px',
    alignContent: 'center',
    height: '80px',
    width: '100%',
  },

  class_text: {
    fontSize: theme.fonts.responsiveSmall,
    color: 'gray',
  },

  main_class_container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  class_container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '2px',
  },

  opacities_class_container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '2px',
  },

  class_line: {
    height: '4px',
    width: '95%',
    borderRadius: '5px',
  },

  birads_category_container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 8px',
    width: '25%',
  },

  birads_category_label: {
    fontSize: theme.fonts.responsiveMediumBig,
    color: '#dbdbdb',
    marginBottom: '8px',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    letterSpacing: '0.05rem',
  },

  lesion_buttons_container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0',
    width: '100%',
  },

  lesion_button: {
    fontSize: '11px',
    height: '30px',
    margin: '0',
    textTransform: 'uppercase',
    fontWeight: '500',
    letterSpacing: '0.02rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    border: '1px solid gray',
    width: '100%',
  },

  diagnostic_table_container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    justifyContent: 'space-between',
  },

  diagnostic_table_shapes: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '10px',
  },

  card_main_container: {
    margin: '0',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },

  diagnostic_header_container: {
    display: 'flex',
    width: '100%',
    padding: '0px 8px',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '30px',
  },

  timelineWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    minHeight: '94px',
    position: 'relative',
    overflow: 'hidden',
  },

  timelineScrollArea: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    padding: '26px 4px 26px 0',
    scrollbarWidth: 'thin',
    scrollbarColor: `${theme.palette.grey[700]} transparent`,
    justifyContent: 'space-between',
  },

  timelineLabelsColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flexShrink: 0,
    height: '60px',
    paddingTop: '1px',
    width: '7%',
  },

  timelineYears: {
    display: 'flex',
    position: 'relative',
    width: 'max-content',
    minWidth: '90%',
    justifyContent: 'flex-start',
  },

  timelineYearColumn: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    overflow: 'visible',
  },

  timelineYearEdge: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '4px',
    height: '60px',
    backgroundColor: '#595959',
    borderRadius: '5px',
    zIndex: 0,
  },

  timelineYearRow: {
    position: 'relative',
    width: '100%',
    minHeight: '28px',
    overflow: 'visible',
    height: '50%',
  },

  timelineMiddleLine: {
    width: '100%',
    height: '4px',
    backgroundColor: '#595959',
    borderRadius: '5px',
    position: 'absolute',
    zIndex: 1,
    top: '50%',
    left: '0',
    right: '0',
    transform: 'translateY(-50%)',
  },

  timelineYearPoint: {
    position: 'absolute',
    transform: 'translateX(-50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    cursor: 'pointer',
    zIndex: 30,
  },

  timelineMarkerShell: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '18px',
    height: '18px',
    zIndex: 20,
  },

  timelinePointDateTop: {
    position: 'absolute',
    top: '-17px',
    left: '50%',
    transform: 'translateX(-50%)',
    fontSize: theme.fonts.responsiveSmall,
    whiteSpace: 'nowrap',
    lineHeight: 1,
  },

  timelinePointDateBottom: {
    marginTop: '4px',
    fontSize: '9px',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    lineHeight: 1,
  },

  timelinePointConnectorTop: {
    position: 'absolute',
    bottom: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '2px',
    height: '100%',
    zIndex: 0,
  },

  timelinePointConnectorBottom: {
    position: 'absolute',
    top: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '2px',
    height: '100%',
    zIndex: 0,
  },

  timelineYearLabel: {
    fontSize: theme.fonts.responsiveSmall,
    fontWeight: 'bold',
    color: theme.palette.text.primary,
    lineHeight: 1,
    marginTop: '2px',
    marginLeft: '-8px',
    position: 'absolute',
    bottom: '-15px',
  },

  timelineLineWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 16px',
    minHeight: '36px',
  },

  timelineLine: {
    position: 'absolute',
    top: '50%',
    left: '0',
    right: '0',
    height: '6px',
    backgroundColor: '#595959',
    transform: 'translateY(-50%)',
    zIndex: 1,
    borderRadius: '5px',
  },

  timelineItem: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 2,
    flex: 1,
    maxWidth: '10%',
    cursor: 'pointer',
  },

  timelineCircle: {
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },

  timelineCircleInner: {
    width: '100%',
    height: '100%',
    transition: 'all 0.3s ease',
    color: 'white',
    fontSize: theme.fonts.responsiveXSmall,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    margin: 0,
    padding: 0,
    borderRadius: '50%',
  },

  timelineContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    minWidth: '180px',
    padding: '8px',
    borderRadius: '5px',
  },

  timelineDate: {
    fontSize: theme.fonts.responsiveMedium,
    color: theme.palette.text.primary,
    marginBottom: '8px',
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
  },

  timelineCurrent: {
    fontSize: theme.fonts.responsiveSmall,
    color: theme.palette.text.secondary,
    marginBottom: '8px',
    whiteSpace: 'nowrap',
  },

  currentStudyIndicator: {
    width: 0,
    height: 0,
    borderLeft: '6px solid transparent',
    borderRight: '6px solid transparent',
    borderBottom: `8px solid rgb(41, 138, 138)`,
    margin: '0 auto',
    position: 'absolute',
    bottom: '-18px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 2,
  },

  timelineEmpty: {
    fontSize: theme.fonts.responsiveMedium,
    color: theme.palette.text.secondary,
    position: 'absolute',
    zIndex: 2,
    padding: '4px 12px',
    borderRadius: '5px',
    background: theme.palette.background.mainDark,
    border: '1px solid gray',
    fontStyle: 'italic',
    left: '50%',
    transform: 'translateX(-50%)',
  },

  timelineLineWrapperEmpty: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '0',
    height: '30px',
  },

  timelineLineEmpty: {
    position: 'absolute',
    top: '50%',
    left: '0',
    right: '0',
    height: '6px',
    backgroundColor: '#595959',
    transform: 'translateY(-50%)',
    zIndex: 1,
    borderRadius: '5px',
  },

  timelineDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    width: '100%',
  },

  timelineDetail: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px',
    fontSize: theme.fonts.responsiveMedium,
  },

  timelineLabel: {
    fontSize: theme.fonts.responsiveMedium,
    color: theme.palette.text.secondary,
    fontWeight: '500',
  },

  timelineValue: {
    fontSize: theme.fonts.responsiveMedium,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '0.05rem',
  },

  diagnostic_table_title: {
    fontSize: theme.fonts.responsiveMediumBig,
    letterSpacing: '0.1rem',
    textTransform: 'uppercase',
    color: '#a9a9a9',
    fontWeight: 'bold',
    paddingLeft: '10px',
  },

  timelineDateDisplay: {
    fontSize: theme.fonts.responsiveSmall,
    color: theme.palette.text.secondary,
    position: 'absolute',
    top: '-30px',
    left: '50%',
    transform: 'translateX(-50%)',
    overflow: 'visible',
    whiteSpace: 'nowrap',
  },

  timelineSideIndicators: {
    display: 'flex',
    justifyContent: 'space-around',
    width: '10%',
    position: 'absolute',
    left: 0,
    height: '100%',
    flexDirection: 'column',
  },

  timelineSideTexts: {
    fontSize: theme.fonts.responsiveSmall,
    color: theme.palette.text.secondary,
  },

  postopIndicator: {
    position: 'absolute',
    top: '0px',
    left: '-11px',
    width: '10px',
    height: '10px',
    zIndex: 3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  operated_indicator: {
    position: 'absolute',
    top: '2px',
    left: '-11px',
    width: '8px',
    height: '8px',
    zIndex: 3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
  },

  newLesionIndicator: {
    position: 'absolute',
    top: '0px',
    right: '-11px',
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    zIndex: 3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  tooltip_texts: {
    letterSpacing: '0.1rem',
    fontSize: theme.fonts.responsiveMedium,
  },

  // postopIndicatorText: {
  //   color: '#ababab',
  //   marginBottom: '2px',
  //   position: 'absolute',
  //   top: '0px',
  //   left: '-16px',
  //   width: '12px',
  //   height: '12px',
  //   borderRadius: '50%',
  //   zIndex: 3,
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  //   fontSize: '9px',
  //   whiteSpace: 'nowrap',
  //   letterSpacing: '0.05rem',
  //   lineHeight: '1',
  // },

  newLesionIndicatorText: {
    color: '#ababab',
    position: 'absolute',
    top: '0px',
    right: '-32px',
    width: '12px',
    height: '12px',
    fontSize: '9px',
    whiteSpace: 'nowrap',
    letterSpacing: '0.05rem',
    lineHeight: '1',
  },

  empty_chip_container: {
    fontSize: theme.fonts.responsiveMedium,
    cursor: 'help',
    height: '100%',
    width: '200px',
    borderRadius: '5px',
    padding: '4px 8px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '30px',
    background: `${theme.palette.diagnosticsClasses.birads1}70`,
  },

  diagnostic_birads_label: {
    fontSize: theme.fonts.responsiveMedium,
    color: 'white',
    fontWeight: 'bold',
    letterSpacing: '0.05rem',
  },
}));
